<template>
    <v-app>
        <v-main>
            <router-view></router-view>
        </v-main>
        <template v-if="error">
            <v-snackbar
                :multi-line="true"
                :timeout="5000"
                color="dark"
                @input="closeError"
                :value="true"
                right
            >
                {{ error }}
                <v-btn
                    dark
                    text
                    @click.native="closeError"
                >
                    Close
                </v-btn>
            </v-snackbar>
        </template>
        <v-footer class="pink">
          <v-col cols="12" class="text-center">
            <div class="">Project 360.teofly read-only. Use new project <a href="https://gis.teofly.com">https://gis.teofly.com</a></div>
          </v-col>

        </v-footer>
    </v-app>
</template>

<script>
export default {

    name: "App",
    beforeCreate() {
        this.$store.dispatch('setAuthorizedStatus');
    },
    methods: {
        closeError () {
            this.$store.dispatch('clearError');
        }
    },
    computed: {
        error () {
            return this.$store.getters.error;
        }
    }
};
</script>
